// Los 8 códigos de requirePermission() en vendia-service (CLAUDE.md §4). `isAccountOwner`
// (is_account_owner en el wire, ver user.model.ts) bypasea todos — nunca lo trates como
// "otro permiso más".
export type Permission =
  | 'view_orders'
  | 'manage_orders'
  | 'manage_payments'
  | 'view_reports'
  | 'edit_catalog'
  | 'reply_messages'
  | 'view_messages'
  | 'manage_bot';

// Fila real de `user_business_permissions` — nombres de campo tal cual el wire format
// (snake_case, sin capa de traducción, ver api-response.model.ts). Booleans planos con
// prefijo `can_`, verificado contra la migración: NO vienen anidados en un objeto
// `permissions: {...}` ni como array de strings, es la fila cruda de la tabla (una por
// usuario+negocio).
export interface UserBusinessPermissions {
  id: string;
  user_id: string;
  business_id: string;
  role: 'manager' | 'operator' | 'viewer';
  can_view_orders: boolean;
  can_manage_orders: boolean;
  can_edit_catalog: boolean;
  can_view_reports: boolean;
  can_manage_bot: boolean;
  can_view_messages: boolean;
  can_reply_messages: boolean;
  can_manage_payments: boolean;
  granted_at: string;
  granted_by_user_id: string | null;
}

// Mapea cada código de Permission a su columna booleana real en UserBusinessPermissions —
// lo usa permission.service.ts para no repetir el switch en cada consumidor.
export const PERMISSION_FIELD: Record<Permission, keyof UserBusinessPermissions> = {
  view_orders: 'can_view_orders',
  manage_orders: 'can_manage_orders',
  manage_payments: 'can_manage_payments',
  view_reports: 'can_view_reports',
  edit_catalog: 'can_edit_catalog',
  reply_messages: 'can_reply_messages',
  view_messages: 'can_view_messages',
  manage_bot: 'can_manage_bot',
};
